/**
 * Show focus rings only while the visitor is actually driving with the
 * keyboard (Jacob, 2026-09-19: "black lines sometimes showing up around
 * items ... make it disappear to the degree possible").
 *
 * The lines are base.css's `*:focus-visible { outline: 1.5px solid
 * currentcolor }`. Nothing is wrong with that rule in principle -- it is the
 * only thing telling a keyboard user where they are -- but :focus-visible is
 * inherited across PROGRAMMATIC focus: when script moves focus, the browser
 * keeps whatever focus-visible state the previous element had. So closing the
 * Klaviyo popup with the mouse handed focus to its teaser, the state came
 * along for the ride, and a hard black 1.5px rectangle in the element's own
 * text colour appeared around a thing nobody had tabbed to. The theme makes 36
 * programmatic .focus() calls of its own (drawer and modal close handlers
 * restoring focus, quick-add, predictive search), which is why it turned up
 * "sometimes" and in no obvious pattern.
 *
 * Rejected: painting the ring white. It is invisible only against white --
 * against the black add-to-cart, a dark hero photograph or dark mode it is the
 * same box in the opposite colour. Rejected too: dropping the ring outright,
 * which would leave keyboard-only shoppers with no way to tell where they are.
 *
 * So the ring is suppressed unless the last input was a key press. Mouse and
 * touch shoppers, which is nearly everyone, never see one; a keyboard shopper
 * sees every one, from their first Tab onwards. The CSS default (in
 * jr-tokens.css) is suppressed, so the ring can only ever appear late, never
 * flash and disappear.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  function mark(mode) {
    if (root.getAttribute('data-jr-input') !== mode) root.setAttribute('data-jr-input', mode);
  }

  /* Capture phase throughout: a component that stops propagation on its own
     handlers must not also stop us from knowing how the page is being driven.
     Shortcut chords (cmd+K, ctrl+F) are the browser being driven, not the
     page, and should not flip a mouse user into keyboard mode. */
  window.addEventListener('keydown', function (event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    mark('keyboard');
  }, true);

  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    window.addEventListener(type, function () { mark('pointer'); }, { capture: true, passive: true });
  });
})();
